import React, { useMemo, useState } from "react";
import Layout from "../components/layout";
import Button from "../components/button";
import Deco from "../components/Deco";

export default function ContactPage() {
  const contactEmail = "casey@alvarezbranding.com";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const mailtoHref = useMemo(() => {
    const subject = `Project inquiry from ${name || "Website visitor"}`;
    const body = [`Name: ${name}`, `Email: ${email}`, "", message]
      .filter(Boolean)
      .join("\n");
    return `mailto:${contactEmail}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  }, [contactEmail, email, message, name]);

  return (
    <Layout>
      <div className="deco-wrap">
        <Deco name="one" className="deco-contact deco-contact--left" />
        <Deco name="two" className="deco-contact deco-contact--right" />
      </div>
      <div className="contact-page">
        <div className="contact-page__inner">
          <h1 className="contact-page__title">Let's chat</h1>
          <p className="contact-page__intro">
            I'm not always taking on new projects, but I'd love to hear what
            you're working on. Drop me a note and let's see if it's a good fit
            to collaborate.
          </p>

          <form
            className="contact-form"
            onSubmit={(e) => {
              e.preventDefault();
              window.location.href = mailtoHref;
            }}
          >
            <div className="contact-form__row">
              <div className="contact-form__field">
                <label className="contact-form__label" htmlFor="contact-name">
                  Name
                </label>
                <input
                  id="contact-name"
                  className="contact-form__input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  autoComplete="name"
                />
              </div>

              <div className="contact-form__field">
                <label className="contact-form__label" htmlFor="contact-email">
                  Email
                </label>
                <input
                  id="contact-email"
                  className="contact-form__input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            <div className="contact-form__field">
              <label className="contact-form__label" htmlFor="contact-message">
                What are you working on?
              </label>
              <textarea
                id="contact-message"
                className="contact-form__input contact-form__textarea"
                rows={6}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Tell me a bit about your project, timeline, and what you're looking for..."
                required
              />
            </div>

            <div className="contact-form__actions">
              <Button onClick={() => (window.location.href = mailtoHref)}>
                Send message
              </Button>
            </div>

            <p className="contact-form__alt">
              Or reach out directly at{" "}
              <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            </p>
          </form>
        </div>
      </div>
    </Layout>
  );
}
